import React from "react";
import { TextField, FormGroup } from "@material-ui/core/";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import { FormStyles } from "../../../../styles";

const Owner = props => {
  const { t } = useTranslation();

  return (
    <div>
      <FormGroup>
        <TextField
          label={t("signup.labels.nom")}
          variant="outlined"
          name={`compteRequestDto[agentCrecheDto][nom]`}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["agentCrecheDto"] &&
                props.touched.compteRequestDto["agentCrecheDto"]["nom"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["agentCrecheDto"] &&
                props.errors.compteRequestDto["agentCrecheDto"]["nom"]}
            </span>
          }
          value={props.values.compteRequestDto.agentCrecheDto.nom}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.prenom")}
          variant="outlined"
          name={`compteRequestDto[agentCrecheDto][prenom]`}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["agentCrecheDto"] &&
                props.touched.compteRequestDto["agentCrecheDto"]["prenom"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["agentCrecheDto"] &&
                props.errors.compteRequestDto["agentCrecheDto"]["prenom"]}
            </span>
          }
          value={props.values.compteRequestDto.agentCrecheDto.prenom}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.email")}
          name={`compteRequestDto[agentCrecheDto][email]`}
          variant="outlined"
          type="email"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["agentCrecheDto"] &&
                props.touched.compteRequestDto["agentCrecheDto"]["email"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["agentCrecheDto"] &&
                props.errors.compteRequestDto["agentCrecheDto"]["email"]}
            </span>
          }
          value={props.values.compteRequestDto.agentCrecheDto.email}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.telephone")}
          name={`compteRequestDto[agentCrecheDto][numeroTel]`}
          variant="outlined"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["agentCrecheDto"] &&
                props.touched.compteRequestDto["agentCrecheDto"]["numeroTel"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["agentCrecheDto"] &&
                props.errors.compteRequestDto["agentCrecheDto"]["numeroTel"]}
            </span>
          }
          value={props.values.compteRequestDto.agentCrecheDto.numeroTel}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.fonction")}
          name={`compteRequestDto[agentCrecheDto][fonction]`}
          variant="outlined"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["agentCrecheDto"] &&
                props.touched.compteRequestDto["agentCrecheDto"]["fonction"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["agentCrecheDto"] &&
                props.errors.compteRequestDto["agentCrecheDto"]["fonction"]}
            </span>
          }
          value={props.values.compteRequestDto.agentCrecheDto.fonction}
        />
      </FormGroup>
    </div>
  );
};

Owner.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(FormStyles)(Owner);
